module.exports = __webpack_public_path__ + "static/media/water_barrier.dc851cc3.png";